/*
 * @Description: DatePicker Provider组件，为应用提供全局DatePicker支持
 */
'use client';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import { useLocale } from 'next-intl';
import { ReactNode } from 'react';

interface DatePickerProviderProps {
  children: ReactNode;
}

/**
 * DatePicker Provider组件，为应用提供全局DatePicker支持
 */
export default function DatePickerProvider({ children }: DatePickerProviderProps) {
  const locale = useLocale();
  const localesMap: Record<string, string> = {
    en: 'en',
    de: 'de',
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localesMap[locale] || 'en'}>
      {children}
    </LocalizationProvider>
  );
}
